//
/**
 * @ngdoc Service
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .service('AppearanceService', AppearanceService)
        .constant("vrmThemes", {
            christmas: "christmas",
            easter: "easter",
            summer: "summer"
        });

    /**
     * @constructor
     * @ngInject
     */
    function AppearanceService(vrmConfig, vrmThemes) {
        const DARK_MODE_KEY = 'darkmode';
        const darkmode = parseInt(localStorage.getItem(DARK_MODE_KEY)) || 0;

        const CUSTOM_THEMES_KEY = 'customThemes';
        const customThemes = localStorage.getItem(CUSTOM_THEMES_KEY) ? JSON.parse(localStorage.getItem(CUSTOM_THEMES_KEY)) : { enabled: true };

        /* Public API */
        var service = {
            model: {
                darkmode: darkmode,
                darkmodeStored: darkmode
            },
            DARK_MODE_KEY,
            toggleDarkMode,
            isDarkModeActive,
            setCustomThemesEnabled,
            isCustomThemesEnabled,
            // Themes specific
            isChristmasThemeActive,
            isChristmasThemeAnimationsActive,
            isEasterThemeActive,
            isEasterThemeAnimationsActive,
            isSummerThemeActive,
            isSummerThemeAnimationsActive
        };

        return service;

        /* Private */

        function toggleDarkMode(dark) {
            if (dark) {
                document.documentElement.classList.add('dark');
            } else {
                document.documentElement.classList.remove('dark');
            }
        }

        function isDarkModeActive() {
            return service.model.darkmode === 1 || (service.model.darkmode === 0 && window.matchMedia('(prefers-color-scheme: dark)').matches);
        }

        function setCustomThemesEnabled(enabled) {
            customThemes.enabled = !!enabled;
            localStorage.setItem(CUSTOM_THEMES_KEY, JSON.stringify(customThemes));
        }

        function isCustomThemesEnabled() {
            return !!customThemes.enabled;
        }

        function isThemeActive(theme) {
            if (!isCustomThemesEnabled()) {
                return false;
            }
            if (theme === vrmThemes.christmas) {
                return vrmConfig.christmasModeEnabled;
            }
            if (theme === vrmThemes.easter) {
                return vrmConfig.easterModeEnabled;
            }
            if (theme === vrmThemes.summer && !isDarkModeActive()) {
                return vrmConfig.summerModeEnabled;
            }
            return false;
        }

        function isThemeAnimationsActive(theme) {
            if (!isCustomThemesEnabled()) {
                return false;
            }

            if (theme === vrmThemes.christmas) {
                return vrmConfig.christmasAnimationsEnabled;
            }

            if (theme === vrmThemes.easter) {
                return vrmConfig.easterAnimationsEnabled;
            }

            if (theme === vrmThemes.summer) {
                return vrmConfig.summerAnimationsEnabled;
            }
            return false;
        }

        // Christmas theme
        function isChristmasThemeActive() {
            return isThemeActive(vrmThemes.christmas);
        }
        function isChristmasThemeAnimationsActive() {
            return isThemeAnimationsActive(vrmThemes.christmas);
        }

        // Easter theme
        function isEasterThemeActive() {
            return isThemeActive(vrmThemes.easter);
        }
        function isEasterThemeAnimationsActive() {
            return isThemeAnimationsActive(vrmThemes.easter);
        }

        // Summer theme
        function isSummerThemeActive() {
            return isThemeActive(vrmThemes.summer);
        }
        function isSummerThemeAnimationsActive() {
            return isThemeAnimationsActive(vrmThemes.summer);
        }
    }
})();
